import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs';
import { ApisService } from 'src/app/shared/services/entities/apis/apis.service';
import { UtilsService } from 'src/app/shared/services/utils.service';

export const CALENDAR_SYNC_CHANNEL = 'calendar_sync_channel';

@Component({
  selector: 'app-google-calendar',
  standalone: true,
  imports: [],
  templateUrl: './google-calendar.component.html',
  styleUrl: './google-calendar.component.scss'
})
export class GoogleCalendarComponent implements OnInit {
  bc: BroadcastChannel = new BroadcastChannel(CALENDAR_SYNC_CHANNEL);

  constructor(
    private apiService: ApisService,
    private route: ActivatedRoute,
    private utils: UtilsService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.pipe(take(1)).subscribe((params) => {
      const state = params['state'];
      const code = params['code'];
      if (state && code) {
        this.apiService.exchangeGoogleCalendarCode({ code, state }).pipe(take(1)).subscribe({
          next: () => {
            this.bc.postMessage({ state });
            window.close();
          }
        });
      } else {
        this.utils.logError(`Missing state or code in query params: ${JSON.stringify(params)}`, 'ULTRA_CRITICAL');
      }
    });
  }
}
